<template>
  <GwBtn
    class="tab w-100"
    :data-tst="'pay_with_' + tab.id"
    variant="btn_large"
    :active="gate === tab.id"
    :disabled="tab.disabled"
    :icon="tab.icon"
    @click="$emit('update:gate', tab.id)"
  >
    <div
      v-if="tab.iconComponents"
      class="d-flex flex-row align-center ga-1"
    >
      <component
        :is="icon"
        v-for="(icon, index) in tab.iconComponents"
        :key="index"
        style="fill: var(--clr-white-0); width: 1rem; height: 1rem"
      />
    </div>
    {{ $t('payment.btns.' + tab.id) }}
  </GwBtn>
</template>

<script>
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'

export default {
  name: 'PaymentTabButton',
  components: {
    GwBtn,
  },
  props: {
    tab: {
      type: Object,
      required: true,
    },
    gate: {
      type: String,
      required: true,
    },
  },
  emits: ['update:gate'],
}
</script>

<style lang="scss" scoped>
.tab {
  padding: 1.25rem 0;
  text-transform: uppercase;
  justify-content: center;
  border-radius: 0.75rem 0.75rem 0 0;
  --surface-bg-hover: rgba(255, 255, 255, 0.025);
  --surface-bg: transparent;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    gap: 0;
    height: 40px;

    & > ::v-deep(.btn_icon) {
      font-size: 1.2rem;
      margin-top: -0.5rem;
      height: 1.5rem;
    }
  }

  &[data-state='active'] {
    --surface-bg-opacity: 1;
    --surface-bg-opacity-hover: 1;
    --surface-bg: rgba(255, 255, 255, 0.125);
    --surface-bg-hover: rgba(255, 255, 255, 0.125);
    &::after {
      background: transparent;
    }
  }

  &[data-state='disabled'] {
    pointer-events: none;
    --surface-bg-opacity: 0;
    --surface-bg-opacity-hover: 0;
    --text-clr: var(--clr-grey-1);
  }
}
</style>
